$(document).ready(function () {
  const triggerModal = (clickedSlide) => {
    clickedSlide.classList.add("active");
    const modal = document.getElementById(clickedSlide.dataset.modalId);
    if (modal) {
      modal.classList.add("active");
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
      modal.addEventListener("click", (event) => {
        if (
          !event.target.closest(".content-slider-modal__close") &&
          event.target.closest(".content-slider-modal__card")
        )
          return;

        modal.classList.remove("active");
        clickedSlide.classList.remove("active");
      });
    }
  };

  const swiper = new Swiper(
    ".content-slider .content-slider-items.swiper-container",
    {
      slidesPerView: 1,
      spaceBetween: 20,
      navigation: {
        nextEl: ".content-slider .swiper-button-next",
        prevEl: ".content-slider .swiper-button-prev",
      },
      on: {
        click: function (swiper, event) {
          const clickedSlide = event.target.closest(".swiper-slide");
          if (!clickedSlide) return;

          triggerModal(clickedSlide);
        },
      },
    },
  );

});
